import { render, staticRenderFns } from "./TrustEconomy.vue?vue&type=template&id=238a9a82&scoped=true&"
import script from "./TrustEconomy.vue?vue&type=script&lang=js&"
export * from "./TrustEconomy.vue?vue&type=script&lang=js&"
import style0 from "./TrustEconomy.vue?vue&type=style&index=0&id=238a9a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a9a82",
  null
  
)

export default component.exports